import React,{useState,useEffect} from 'react'
import picsGalleryMarathon from "./PicsMarathon";

function WorkGallery() {
    const [filter] = useState('all');
    const [projects, setProjects] = useState([]);

    useEffect(() => {
        setProjects(picsGalleryMarathon);
    }, [setProjects]);

    useEffect(() => {
        setProjects([]);
        const filtered = picsGalleryMarathon.map(p => ({ ...p, filtered: p.category.includes(filter) }));
        setProjects(filtered);
    }, [filter]);

    return (
        <div className="event-container">

            <div className="container">
                <div className="auto-container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="about-content text-left" data-aos="fade-down">
                                <div className="sec-title">
                                    <h4>Marathon Gallery</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="portfolio-list">
                                {
                                    projects.map(item => item.filtered === true ? (
                                        <div key={item.id} className={`portfolio__container single-portfolio-item ${item.size} ${item.image}`} >
                                            <div className="details">
                                                <div className="info">
                                                    <a href={item.image}><i className="las la-search-plus"></i></a>
                                                </div>
                                            </div>
                                        </div>
                                    ) : '')
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WorkGallery
